import { ClearFilters, LocationFilter, StatusFilter, TopicsFilter } from '#src/app/pages/search/shared/components';

export const DesktopFilters: React.FC = () => {
	return (
		<div className="col-span-3 hidden flex-col items-start justify-start gap-12 md:flex">
			<LocationFilter showTitle />
			<StatusFilter desktopView />
			<TopicsFilter showTitle trackingContext="topic_filter" />
			<div className="mt-4">
				<ClearFilters />
			</div>
		</div>
	);
};
